import { moduleFactory } from "@/factories/module";
import { easeInCubic } from "@/modules/animations/easeInCubic";

export const animationsModule = moduleFactory.create({
  easeInCubic,
});
